<template>
    <div>
        <app-header></app-header>
        <div class="container">

            <div class="column">
                <rev-card :reviewable="reviewable"></rev-card>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'

    export default {
        mixins: [GetAxiosAuthConfig],
        data() {
            return {
                reviewable: Object,
            }
        },
        methods: {
            GetRandomReviewable() {
                // Use the URL rather than the filter for ID
                let resturl = window.location.origin + '/api/reviewables/random/?format=json'
                axios
                    .get(resturl, axios_auth_config)
                    .then(response => (this.reviewable = response.data.results))
                    .catch(error => console.log(error))
            },
        },
        mounted() {
            this.GetRandomReviewable()
        },
    }
</script>

<style>
</style>
